import { __decorate, __metadata } from 'tslib';
import { ReplaySubject } from 'rxjs';
import { StateManager } from '../../services/store/state-manager.js';
import { WorkbenchMountSettings } from '../../services/settings/auto-sync-settings.js';
import { InjectorService } from '@tencent/ioc';
import { Service } from '../../decorators/class/service.js';

/**
 * 加载增量service
 * @internal
 */
let MountService = class MountService {
    constructor(store) {
        this.store = store;
        this.serviceSettingsChange = new ReplaySubject();
        this.store.register(WorkbenchMountSettings.Services, []).subscribe(this.serviceSettingsChange);
    }
    /**
    * 监听增量service变化
    * @internal
    */
    subscribeToSettingServicesChange() {
        this.serviceSettingsChange.subscribe((services) => {
            services === null || services === void 0 ? void 0 : services.forEach(item => InjectorService.get(item));
        });
    }
};
MountService = __decorate([
    Service(),
    __metadata("design:paramtypes", [StateManager])
], MountService);

export { MountService };
//# sourceMappingURL=mount-service.js.map
